import { create } from 'zustand';

interface RecapStore {
  exportingRecapIds: string[];
  addExportingRecapIds: (ids: string[]) => void;
  removeExportingRecapIds: (ids: string[]) => void;
  reset: () => void;
}

export const useRecapStore = create<RecapStore>()((set) => ({
  exportingRecapIds: [],
  addExportingRecapIds: (ids) =>
    set((state) => ({
      exportingRecapIds: Array.from(new Set([...state.exportingRecapIds, ...ids])),
    })),
  removeExportingRecapIds: (ids) =>
    set((state) => ({
      exportingRecapIds: state.exportingRecapIds.filter((id) => !ids.includes(id)),
    })),
  reset: () => set({ exportingRecapIds: [] }),
}));
